// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// Import projects data
import TrackingSheet from "layouts/tracking/components/TrackingSheet";

function Tracking() {
  return (
    <DashboardLayout>
      <TrackingSheet />
      <Footer />
    </DashboardLayout>
  );
}

export default Tracking;
